import classNames from 'classnames'
import type { HTMLAttributes, ReactNode } from 'react'

export interface ButtonSetProps extends HTMLAttributes<HTMLDivElement> {
	className?: string
	/**
	 * ```
	 * <StandaloneLink /> | <Button />
	 * ```
	 */
	children: ReactNode
}

function ButtonSet({ className, children, ...rest }: ButtonSetProps) {
	return (
		<div className={classNames('hds-button-set', className)} {...rest}>
			{children}
		</div>
	)
}

export default ButtonSet
